export default __webpack_public_path__ + "static/media/Party.8dd0325f.jpg";